/* eslint-disable func-names */
const launchWindow = (url, title = '', w = 0.85 * window.screen.width, h = 0.85 * window.screen.height) => {
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  const windowParams = { toolbar: ['no'], location: ['no'], directories: ['no'], status: ['no'], menubar: ['no'], scrollbars: ['yes'], resizable: ['yes'], copyhistory: ['no'] };
  const windowDims = { width: [w], height: [h], top: [top], left: [left] };

  const windowP = new URLSearchParams();
  Object.keys(windowParams).map((k) => windowParams[k].map((v) => windowP.append(`${k}[]`, v)));

  const windowD = new URLSearchParams();
  Object.keys(windowDims).map((k) => windowDims[k].map((v) => windowD.append(`${k}[]`, v)));

  const externalWindow = window.open(`${url}`, '_blank', `${windowP.toString().replace(/&/g, ', ')}, ${windowD.toString().replace(/&/g, ', ')}`);
  try {
    externalWindow.onload = function (e) {
      e.target.title = title;
    };
    return externalWindow;
  } catch (e) {
    // return this.get('toastService').error(this.get('intl').t('labels.please_check_your_popup_window_settings'));
  }
  return undefined;
};

const launchNewTab = (url, { title, features = null }) => {
  const externalWindow = window.open(`${url}`, '_blank', features);

  if (title)
    externalWindow.onload = function (e) {
      e.target.title = title;
    };
  if (externalWindow) externalWindow.opener = null;
  return externalWindow;
};

export default { launchWindow, launchNewTab };
